import { jwtDecode } from 'jwt-decode';
import { JwtPayload } from '@infrastructure/jwt/types/jwtPayload';

export const decodeJwt = (token: string): JwtPayload => {
    return jwtDecode<JwtPayload>(token);
};




